<template>
    <v-card
        tile
        flat
        class="TitleCard"
        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-sheet
                        class="mb-0"
                        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                    >
                        <h2 class="mt-0">
                            {{
                                mt5AccountDetails?.tradingaccounttypes
                                    ?.account_type_display
                            }}
                        </h2>
                        <p class="mb-0">
                            MT5 - {{ mt5AccountDetails?.trading_account_no }}
                        </p>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState("trading", ["mt5AccountDetails"]),
    },
    methods: {
        ...mapActions("trading", [TRADING__ACTIONS.MT5ACCOUNTDETAILS]),
    },
    async mounted() {
        await this[TRADING__ACTIONS.MT5ACCOUNTDETAILS](this.$route.query.id);
    },
};
</script>
